import { SetActive } from '@clerk/types';

type HandleClerkRedirectParams = {
  sessionId: string;
  redirectTo?: string;
  getToken: () => Promise<string | null>;
  setActive: SetActive;
  allowedCustomSchemes?: string[];
  onAfterSuccess?: () => void;
};

export default async function handleSetActive({
  sessionId,
  redirectTo,
  getToken,
  setActive,
  allowedCustomSchemes = ['boatsetter-renters', 'boatsetter-owners'],
  onAfterSuccess,
}: HandleClerkRedirectParams): Promise<void> {
  if (!sessionId) throw new Error('Missing session ID');

  const isCustomScheme = redirectTo && allowedCustomSchemes.some((scheme) => redirectTo.startsWith(scheme));
  await setActive({ session: sessionId });

  if (isCustomScheme) {
    const token = await getToken();
    window.location.href = `${redirectTo}?session_token=${token}`;
  } else {
    await setActive({ session: sessionId, redirectUrl: redirectTo });
  }

  if (onAfterSuccess) {
    onAfterSuccess();
  }
}
